<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let type = 'text-two';

let className = '';

switch (type) {
  case 'text-two':
    className = 'skeleton-text-two';
    break;
  case 'text-landingpage':
    className = 'skeleton-text-landingpage';
    break;
  case 'button':
    className = 'skeleton-button';
    break;
  default:
    className = 'skeleton-text-two';
}
</script>

<div class={`skeleton-base ${className}`}></div>

<style>
  .skeleton-base {
    position: relative;
    background-color: #dbd9d7;
    background-image: -webkit-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: -o-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-size: 600px;
    -webkit-animation: shine-loading-image 3s infinite ease-out;
    animation: shine-loading-image 3s infinite ease-out;
    background-repeat: no-repeat;
  }
  .skeleton-text-landingpage {
    height: 1rem;
    width: 100%;
    max-width: 250px;
    margin: 8px auto;
  }

  .skeleton-text-landingpage:after {
    content: "";
    height: 1rem;
    width: 80%;
    display: block;
    margin: 24px auto 0;
    background-color: var(--bg-color, #dbd9d7);
    background-image: linear-gradient(
      120deg,
      var(--bg-color, #dbd9d7) 0px,
      rgba(255, 255, 255, 0.3) 50px,
      var(--bg-color, #dbd9d7) 100px
    );
    background-size: 600px;
    animation: shine-loading-image 3s infinite ease-out;
    background-repeat: no-repeat;
    border-radius: 4px;
  }
  .skeleton-text-two {
    height: 1rem;
    width: 500px;
    margin: 12px 0 1.75rem;
  }

  .skeleton-text-two:after {
    content: "";
    height: 1rem;
    width: 75%;
    display: inline-block;
    position: absolute;
    top: 1.5rem;
    left: 0;
    background-color: #dbd9d7;
    background-image: -webkit-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: -o-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-size: 600px;
    -webkit-animation: shine-loading-image 3s infinite ease-out;
    animation: shine-loading-image 3s infinite ease-out;
    background-repeat: no-repeat;
  }

  .skeleton-button {
    display: inline-block;
    height: 2rem;
    width: 6rem;
    margin: 10px;
  }

  @-webkit-keyframes shine-loading-image {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 600px;
    }
  }

  @keyframes shine-loading-image {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 600px;
    }
  }
</style>
